<div style='display: flex;flex-direction: row; gap: 25px; margin-top: 30px'>
    <div class='display-wrapper'>
        <slot name='col-1'></slot>
    </div>
    <div class='sticky-wishlist flex-1'>
        <slot name='sticky'></slot>
    </div>
</div>

<style>
    .display-wrapper {
        width: 65%;
    }

    .sticky-wishlist {
        width: 400px;
        font-size: 1.2rem;
        display: flex;
        flex-direction: column;
        align-items: center;
    }

    @media screen and (max-width: 1100px) {
        .display-wrapper {
            width: 55%;
        }
    }

    @media screen and (max-width: 700px) {
        .sticky-wishlist {
            display: none;
        }

        .display-wrapper {
            width: 100%;
        }
    }
</style>